<!--  ############### Top Select Month Start ################# -->
<div class="select_month_section">
	<section class="row">
		<div class="select_month col-auto">
			<h2><label for="select_year_month">{{"SELECTMONTH" | translate}}</label> </h2>
			<select 
			class="form-select" 
			aria-label="Month selection"
			[(ngModel)]="dropDowndate"
			(change)="fncCng($event)">
				<option *ngFor="let date of monthDropdown" [value]="date.dayDate">
					<!-- {{ "DDMONTH."+getMonth(date) | translate}} {{getYear(date)}} -->
                      {{(lang == 'en') ? date.eNdate: date.jPdate}}
				</option>
			</select>
		</div>
		
		</section>
</div>
<!--  ############### Top Select Month End ################# -->
<!--  ############### Middle Containt Area Start ################# -->
<div class="container_wrapper">
    <div class="client_associate_list">
        <p-table 
        #dt2
        [value]="companyList" [tableStyle]="{'width':'100%'}" 
        [paginator]="true"
        [rows]="10"
        [showCurrentPageReport]="true"
        [globalFilterFields]="['company']"
        currentPageReportTemplate="{{'Showing' |translate}} {first} {{'to' | translate}} {last} {{'of' | translate}} {totalRecords} {{'entries' | translate}}"
        (onFilter)="onFilter($event)"
        (onPage)="onPage($event)">
        <!-- (onSort)="onSort()" -->
        <!-- <table class="display nowrap table table-striped" style="width:100%"> -->
            <ng-template #caption>
                
                    <p-iconfield iconPosition="left" class="ml-auto">                        
                        <label>{{"SearchByText" | translate}}:</label>
                        <input pInputText type="text" (input)="onGlobalFilter($event)" placeholder="{{'SearchKey' | translate}}" />
                    </p-iconfield>
                
            </ng-template>
            <ng-template pTemplate="header">                
                <!-- <thead> -->
                    <tr class="tbl_head">
                        <th rowspan="2" class="bor_lft_none">{{"Company" | translate}}</th>
						<th colspan="4">{{"STATUS" | translate}}</th>
						<th rowspan="2">{{"NoOfResource" | translate}}</th>
						<th rowspan="2">{{"Create" | translate}}</th>
                    </tr>
					
                    <tr class="tbl_head">
                        <th>Not Submit</th>
						<th>{{"SUBMIT" | translate}}</th>
						<th>{{"REJECT" | translate}}</th>
						<th>{{"APPROVE" | translate}}</th>                        
                    </tr>
                <!-- </thead>     -->
            </ng-template>
            <ng-template pTemplate="body" let-item>
                <tr class="tbl_cont">
                	<td><a href="timesheet-section/{{item.companyId}}/{{timeSheetDateOrg}}" class="dlt_link">{{item.company}}</a></td>
                    <td>{{item.notSubmit}}</td>
                    <td>{{item.submit}}</td>
                    <td>{{item.reject}}</td>
                    <td>{{item.approve}}</td>
                    <td>{{item.userCount}}</td>
                    <td><button class="btn btn-primary btn-sm" (click)="createSingle(item.companyOrgId, selectedDate)"><i class="bi bi-plus-circle"></i> {{"Create" | translate}}</button></td>
                    
                </tr>
            </ng-template>
            <ng-template pTemplate="footer">
                <tr class="tbl_fot">
                    <td>{{"TOTAL" | translate}}</td>
                        <td>{{ totalNotSubmit }}</td>  <!-- Regular total -->
						<td>{{ totalSubmit }}</td>  <!-- Overtime total -->
						<td>{{ totalReject }}</td>  <!-- Midnight total -->
						<td>{{ totalApprove }}</td>  <!-- Overall total -->
						<td>{{ totalUser }}</td>  <!-- Not Submit -->						
						<td><button class="btn btn-primary btn-sm" (click)="createSingle('-1', selectedDate)" *ngIf="companyList && companyList.length > 0"><i class="bi bi-folder-check"></i> {{"All" | translate}}</button></td>
                </tr>
                </ng-template>            
        </p-table>
		<!-- <caption>To specify by usergroup click Customer's Name(Blue).</caption> -->
    </div>
	
	<!--  ############### Data Table Start ################# -->
	<div class="time_sheet_table_wrapper client_associate_list">
		<p-table 
        #dt2
        [value]="userLogList" [tableStyle]="{'width':'100%'}" 
        [paginator]="true"
        [rows]="10"
        [showCurrentPageReport]="true"        
        currentPageReportTemplate="{{'Showing' |translate}} {first} {{'to' | translate}} {last} {{'of' | translate}} {totalRecords} {{'entries' | translate}}">
        <!-- (onSort)="onSort()" -->        
            <ng-template pTemplate="header">                
                <!-- <thead> -->
                    <tr class="tbl_head">
                        <th>{{"CreatedDate" | translate}}</th>
						<th>{{"SelectedMonth" | translate}}</th>
						<th>{{"Company" | translate}}</th>
						<th>{{"Section" | translate}}</th>
						<th>{{"NOTSUBMIT" | translate}}	</th>
						<th>{{"SUBMIT" | translate}}</th>
						<th>{{"REJECT" | translate}}</th>
						<th>{{"APPROVE" | translate}}</th>
						<th>{{"NoOfResource" | translate}}</th>
						<!-- <th>{{"Download" | translate}}</th>
						<th>{{"Delete" | translate}}</th> -->
                    </tr>
            </ng-template>
            <ng-template pTemplate="body" let-user>
                <tr class="tbl_cont">
                	<td>{{user.procDetailsData.CreatedDate}}</td>
                    <td>{{"DDFULLMONTH."+getSelectedMonth(user.procDetailsData.StartDate) | translate}}</td>
                    <td>{{user.procDetailsData.CompanyName}}</td>
                    <td>{{user.procDetailsData.SectionName}}</td>
                    <td>{{user.procDetailsData.NotSubmitted}}</td>
                    <td>{{user.procDetailsData.Submitted}}</td>
                    <td>{{user.procDetailsData.Rejected}}</td>
                    <td>{{user.procDetailsData.Approved}}</td>
                    <td>{{user.procDetailsData.ResourceCount}}</td>
                    <!-- <td><a href="javascript:void(0)">{{user.procDetailsData.FileName}}</a></td>
                    <td><button class="btn btn-primary btn-sm"><i class="bi bi-trash"></i> {{"Delete" | translate}}</button></td> -->
                </tr>
            </ng-template>            
        </p-table>            
	</div>	
	<!--  ############### Data Table End ################# -->	
</div>
<!--  ############### Middle Containt Area End ################# -->